<app-base-modal
  [title]="'Обновление пароля'"
>
  <form [formGroup]="changePasswordFormGroup">
    <mat-form-field appearance="outline">
      <mat-label>Новый пароль</mat-label>
      <input
        formControlName="password"
        matInput
        required
        [type]="passwordVisible ? 'password' : 'text'"
        (change)="handleNewPasswordInputChange($event)"
      >
      <button
        mat-icon-button
        type="button"
        matSuffix
        (click)="togglePasswordVisibility()"
      >
        <mat-icon>{{ passwordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-error> Минимальная длина пароля: {{ MIN_PASSWORD_LENGTH }} символов </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Повторите пароль</mat-label>
      <input
        formControlName="confirmPassword"
        matInput
        required
        [type]="confirmPasswordVisible ? 'password' : 'text'"
        pattern="{{ changePasswordFormGroup.value.password }}"
      >
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="toggleConfirmPasswordVisibility()"
      >
        <mat-icon>{{ confirmPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-error> Пароли не совпадают </mat-error>
    </mat-form-field>

    <div class="buttons-container">
      <button
        mat-button
        color="primary"
        type="button"
        (click)="closeDialog('cancel')"
      >
        Закрыть
      </button>
      <button
        mat-button
        color="primary"
        type="button"
        [disabled]="changePasswordFormGroup.invalid"
        (click)="changePassword()"
        (keydown.enter)="changePassword()"
      >
        Обновить
      </button>
    </div>
  </form>
</app-base-modal>
